import { z } from 'zod';
export const EntityMatchingBestMatchSchema = z.object({
    matchReason: z.string().nullish()
});
export const EntityMatchingSchema = z.object({
    bestMatch: EntityMatchingBestMatchSchema.nullish()
}).passthrough().meta({
    id: 'EntityMatching'
});

//# sourceMappingURL=entity-matching.schema.js.map